<template>
  <div class="index">
    <img class="IFLOFO" :src="logoSrc" />
    <h2>云天励飞会议预定系统</h2>
  </div>
</template>
<script>
import { Toast } from 'vant';
import logoSrc from '@/assets/img/IF.png';
import api from '@/services/api';
import router from '@/router';
export default {
  data() {
    return {
      logoSrc,
    };
  },
  mounted() {
    const { ticket } = this.$route.query;
    Toast.loading('正在加载用户信息', 0);
    api.getTokenByTicketServices({ ticket }).then(res => {
      setTimeout(() => {
        Toast.clear();
      }, 1000);
      if (res.respCode == 10000000) {
        sessionStorage.setItem('token', res.data.token);
        sessionStorage.setItem('userInfo', res.data);

        router.push('/773/meeting/booking');
      }
    });
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  height: 100%;
  position: relative;
  .IFLOFO {
    display: block;
    margin: 0 auto;
    padding-top: 2rem;
  }
  h2 {
    font-size: 0.36rem;
    line-height: 0.4rem;
    color: #333;
    text-align: center;
    letter-spacing: 0.17px;
    margin-top: 0.4rem;
  }
  .am-list-body {
    border: 0 !important;
  }
}
</style>
